export default __webpack_public_path__ + "static/media/rembolsado.c48b2e0e.png";